export default __webpack_public_path__ + "static/media/team1.4fddee8e.png";